import { Record } from 'immutable';

const MatchingPropertyAssignRecord = Record({
  'matchingPropertyId': null,
  'vendorSource': null,
  'vendorId': null,
  'chain': null,
  'brand': null,
  'pid': null,
  'name': null
});

export class MatchingPropertyAssign extends MatchingPropertyAssignRecord {
  matchingPropertyId: number;
  vendorSource: string;
  vendorId: string;
  chain: string;
  brand: string;
  pid: string;
  name: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/matching-property-assign.ts